<div class="row">
  <div class="columns small-12 medium-6 user-edit-profile">
    <div class="body" style="padding: 15px;">
      <div class="d-flex flex-column ps-3 pe-3 new-input-fields">
        <div class="d-flex flex-column w-100">
          <div>
            <label>Firm Name*</label>
          </div>
          <div>
            <label>
              <input type="text" [(ngModel)]="firmName" placeholder="Firm Name"/>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column w-100">
          <div>
            <label>Firm Disclaimer</label>
          </div>
          <div>
            <label>
              <textarea [(ngModel)]="firmDisclaimer" placeholder="Firm Disclaimer" rows="4"></textarea>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column w-100">
          <div>
            <label>First Name*</label>
          </div>
          <div>
            <label>
              <input type="text" [(ngModel)]="userProfileData.firstName" placeholder="First Name"/>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column w-100">
          <div>
            <label>Last Name*</label>
          </div>
          <div>
            <label>
              <input type="text" [(ngModel)]="userProfileData.lastName" placeholder="Last Name"/>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div>
            <label>Email*</label>
          </div>
          <div>
            <label>
              <input type="text" [(ngModel)]="userProfileData.id" placeholder="Email" disabled/>
              <div class="error" *ngIf="userProfileData.id && !userProfileData.id.match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')">Please check email format</div>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div>
            <label>Phone</label>
          </div>
          <div>
            <label>
              <input type="text" input-mask [(ngModel)]="userProfileData.phoneNumber" placeholder="Phone"/>
            </label>
          </div>
        </div>
        <div class="mt-3" *ngIf="showChangePassword">
          <div class="d-flex flex-column w-100">
            <div>
              <label>New Password*</label>
            </div>
            <div>
              <label>
                <input type="password" [(ngModel)]="newPassword" placeholder="New Password" />
              </label>
            </div>
          </div>

          <div class="d-flex flex-column w-100">
            <div>
              <label>Confirm Password*</label>
            </div>
            <div>
              <label>
                <input type="password" [(ngModel)]="confirmPassword" placeholder="Confirm Password" />
              </label>
            </div>
          </div>

          <div class="error" *ngIf="passwordErrors && passwordErrors.length">
            <div *ngFor="let err of passwordErrors">{{ err }}</div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">
          <button class="button small" type="button" (click)="toggleChangePassword()">
            {{ showChangePassword ? 'CANCEL PASSWORD CHANGE' : 'CHANGE PASSWORD' }}
          </button>

          <button class="button small" type="button" (click)="updateProfileAndFirm()">UPDATE</button>
        </div>
      </div>
    </div>
  </div>
</div>
